import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse, HttpStatusCode
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {alert} from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import {StatusCodes} from 'http-status-codes';
import {Observable, throwError} from 'rxjs';
import * as Sentry from '@sentry/angular-ivy';
import {catchError, flatMap, tap} from 'rxjs/operators';
import {FusionAuthService} from '../services/fusion-auth';
import {StorageService} from '../services/general';
import {handleJWTRefresh} from "./common";

@Injectable({
  providedIn: 'root',
})
export class GlobalHttpInterceptorService implements HttpInterceptor {
  constructor(
    private router: Router,
    private storage: StorageService,
    private fusionAuthService: FusionAuthService,
  ) {
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      // @ts-ignore
      catchError(error => {
        Sentry.setContext('global-http-interceptor', {
          ...req
        });
        Sentry.captureException(error);

        if (!(error instanceof HttpErrorResponse)) {
          notify('We are having trouble to succeed your request!', 'error');
          return throwError(error);
        }
        if (!navigator.onLine) {
          notify('It seems that your internet connection it\'s not stable!', 'error');
          return throwError(error);
        }

        switch (error.status) {
          case 0:
            notify('We have lost communication with our servers!', 'error');
            break;
          case StatusCodes.BAD_REQUEST:
            notify('There was a validation error!', 'error');
            break;
          case StatusCodes.INTERNAL_SERVER_ERROR:
            notify('Oops, an internal error occurred!', 'error');
            break;
          case StatusCodes.REQUEST_TIMEOUT:
          case StatusCodes.GATEWAY_TIMEOUT:
            notify('It seems that you are having problems communicating with our servers!', 'error');
            break;
          case StatusCodes.NOT_FOUND:
            if (this.router.url !== '/login') {
              notify('No record found!', 'error');
            } else {
              notify('The user and password combination was not recognized.', 'error');
            }
            break;
          case StatusCodes.CONFLICT:
            notify('The record already exists!', 'error');
            break;
          case StatusCodes.SERVICE_UNAVAILABLE:
            notify('The record couldn\'t be created, please try later.', 'error');
            break;
          case StatusCodes.UNAUTHORIZED:
            const token = this.fusionAuthService.getToken();
            if (token) {
              req = req.clone({
                setHeaders: {
                  Authorization: 'JWT ' + token,
                },
              });
            }
            if (this.router.url !== '/login' && this.fusionAuthService.getRefreshToken()) {
              return this.fusionAuthService.exchangeRefreshTokenForJWT().pipe(
                tap((response: any) => {
                  if (response.status === HttpStatusCode.Ok) {
                    req = req.clone({
                      setHeaders: {
                        Authorization: 'JWT ' + response.body.token,
                      },
                    });

                    return next.handle(req);
                  } else {
                    return this.router.navigateByUrl('/login');
                  }
                }),
              );
            }
            break;
          default:
            alert('Sorry, we are having problems processing your request, the page will reload in a few seconds.', 'Critical Error').then();
            setTimeout(() => window.location.reload(), 10000);
            break;
        }

        return throwError(error);
      }),
    );
  }
}
